import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enElementLocale from 'element-ui/lib/locale/lang/en';
import deElementLocale from 'element-ui/lib/locale/lang/de';
import enLocale from './en';
import deLocale from './de';

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale,
    ...enElementLocale,
  },
  de: {
    ...deLocale,
    ...deElementLocale,
  },
};

export function getLanguage() {
  const language = (navigator.language || navigator.browserLanguage).toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return 'en';
}
const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: 'en',
  messages,
});

export default i18n;
